import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "./campaignDetail.css";
import ReactHtmlParser from "react-html-parser";
import Footer from "../../component/Footer";
import CampaignForm from "../../component/CampaignForm/";
import LoadingIndicator from "../../component/LoadingIndicator";
import {getCampaignDetail, requestCampaignCode} from "../../util/APIUtils";
import FuelCampaignForm from "../../component/CampaignForm/FuelCampaignForm";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {showAxiosError, createImageUrl} from "../../util/Helpers";
import {Button} from "antd";
import {CampaignFormType} from "../../util/Enums";
import HotelCampaignForm from "../../component/CampaignForm/HotelCampaignForm";
import "../../util/explorer_support";
import {VirtualHost} from "../../constants";

function CampaignDetail() {
    let {campaignId} = useParams();
    const [expand, setExpand] = useState(false);
    const [campaign, setCampaign] = useState([]);
    const [termsOfUse, setTermsOfUse] = useState([]);
    const [loading, setLoading] = useState(false);
    const [campaignCode, setCampaignCode] = useState(undefined);

    useEffect(() => {
        getCampaignDetailAPI();
    }, []);

    function requestCode() {
        requestCampaignCode(campaign.campaignCodeType).then((response) => {
            if (response && response.data) {
                setCampaignCode(response.data.code);
            }
        }).catch((error) => {
            showAxiosError(error.response)
        })
    }

    function getCampaignDetailAPI() {
        setLoading(true);
        // getCampaignDetail(campaignHead.replace(/%23?/g, "#")
        //     .replace(/%3A?/g, ":")
        //     .replace(/%%25?/g, "%")
        //     .replace(/%2C?/g, ",")
        //     .replace(/#C?/g, ",")
        //     .replace(/\d+% ?/g, "")).then((response) => {
        //     if (response && response.data) {
        //         let item = response.data
        //         setCampaign(item);
        //         setTermsOfUse(item.termsOfUse ? item.termsOfUse.split("\n") : [])
        //         setLoading(false);
        //     } else {
        //
        //     }
        // }).catch(error => {
        //     showAxiosError(error.response);
        //     setLoading(false);
        // });
        getCampaignDetail(campaignId).then((response) => {
            if (response && response.data) {
                let item = response.data
                if (item !== null) {
                    if (item.description !== null && item.description !== "") {
                        item.description = item.description.replaceAll("[companyName]", VirtualHost.companyName);
                    }

                    if (item.baseHeader !== null && item.baseHeader !== "") {
                        item.baseHeader = item.baseHeader.replaceAll("[companyName]", VirtualHost.companyName);
                    }
                }
                setCampaign(item);
                setTermsOfUse(item.termsOfUse ? item.termsOfUse.split("\n") : [])
                setLoading(false);
            }
        }).catch(error => {
            showAxiosError(error.response);
            setLoading(false);
        });
    }

    return loading ? (
        <LoadingIndicator/>
    ) : (
        <div>
            <div className="full-w align-center d-flex flex-d-col">
                <div
                    key={campaign.recordId}
                    className="campaign-detail-area d-flex flex-d-col"
                >
                    <img src={createImageUrl(campaign, "campaignImage")} alt=""/>
                    <div>
                        <h4>{ReactHtmlParser(campaign.baseHeader)}</h4>
                        <p>{ReactHtmlParser(campaign.description)}</p>
                        {termsOfUse && termsOfUse.length > 0 && <h5>Kullanım Koşulları: </h5>}
                        {termsOfUse.map((item, index) => {
                            if (item != null && item !== "") {
                                return <li key={index}>{ReactHtmlParser(item)}</li>
                            }
                        })}
                    </div>
                    {campaign.formDisplay ? <a
                        style={{
                            fontSize: 17,
                            fontWeight: "bold"
                        }}
                        onClick={() => {
                            setExpand(!expand);
                        }}
                    >
                        {expand ? <UpOutlined/> : <DownOutlined/>}
                        {campaign.formType === CampaignFormType.HOTEL ? "Yurtiçi Otel bilgileri için tıklayınız" : "Başvurmak için tıklayınız."}
                    </a> : null}
                    {(expand && campaign.formType === CampaignFormType.FUEL) && <FuelCampaignForm campaignId={campaign.recordId} baseHeader={campaign.baseHeader}/>}
                    {(expand && campaign.formType === CampaignFormType.NORMAL) && <CampaignForm campaignId={campaign.recordId}/>}
                    {(campaign.hasCampaignCode && !campaignCode) &&
                        <Button onClick={() => requestCode()} type="primary">Kod Talep Et</Button>}
                    {(campaign.hasCampaignCode && campaignCode) &&
                        <div><p style={{fontSize: 20}}>{campaign.description && (campaign.description.includes("beko") || campaign.description.includes("arcelik")) ? "Doğruluma Kodunuz: " : "Kampanya Kodunuz: "} <b>{campaignCode}</b></p></div>}
                    {expand && campaign.formType === CampaignFormType.HOTEL && <HotelCampaignForm />}
                    <br/>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default CampaignDetail;



// WEBPACK FOOTER //
// ./src/page/campaignDetail/index.js